const HOST_URL = process.env.REACT_APP_API_HOST_URL || 'https://api.dev.platform.revenueos.io';
const APP_BASE_URL = process.env.REACT_APP_APP_BASE_URL || 'http://localhost:3005';

const HUBSPOT_CLIENT_ID = process.env.REACT_APP_HUBSPOT_CLIENT_ID
  || '7e3b643a-cad8-44f3-a06f-0d7b74d23216';
const SALESFORCE_CLIENT_ID = process.env.REACT_APP_SALESFORCE_CLIENT_ID
  || '3MVG9Ud3b0C7Knniap60rSVEN13PPiEuaiwCWejM2bWxptfSLfI6mhtvkqBXJNjoiuuoE3u6BLCz4mAO5w2OU';

const HUBSPOT_OAUTH_URL = process.env.REACT_APP_HUBSPOT_OAUTH_URL
  || 'https://app-eu1.hubspot.com/oauth/authorize';
const SALESFORCE_OAUTH_URL = process.env.REACT_APP_SALESFORCE_OAUTH_URL
  || 'https://login.salesforce.com/services/oauth2/authorize';

/* If there is a space in the full name of the platform,
 the variable name should have an underscore instead of the space */
const PlatformDataForIntegrationPage = {
  hubspot: { 
    fullName: 'HubSpot', 
    integrationURL: `${HUBSPOT_OAUTH_URL}?client_id=${HUBSPOT_CLIENT_ID}`
      + `&redirect_uri=${APP_BASE_URL}/settings/integrations/hubspot/redirect`
      + '&scope=crm.lists.read%20crm.objects.contacts.read%20crm.schemas.contacts.read'
      + '%20crm.objects.companies.read%20crm.objects.deals.read%20crm.schemas.companies.read'
      + '%20crm.schemas.deals.read%20crm.objects.owners.read', 
  },
  salesforce: { 
    fullName: 'Salesforce', 
    integrationURL: `${SALESFORCE_OAUTH_URL}?client_id=${SALESFORCE_CLIENT_ID}`
      + `&redirect_uri=${APP_BASE_URL}/settings/integrations/salesforce/redirect&response_type=code`, 
  },
};

export { HOST_URL, PlatformDataForIntegrationPage };
